import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=6b1b18b2&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b18b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b1b18b2')) {
      api.createRecord('6b1b18b2', component.options)
    } else {
      api.reload('6b1b18b2', component.options)
    }
    module.hot.accept("./OverviewPage.vue?vue&type=template&id=6b1b18b2&scoped=true", function () {
      api.rerender('6b1b18b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/pages/OverviewPage.vue"
export default component.exports